export enum NavigationOption {
  showAlways = 'showalways',
  hideOnMobile = 'hideonmobile',
  hideOnDesktop = 'hideondesktop',
  hideAlways = 'hidealways',
}
